<div fxLayout="column" fxLayoutAlign="stretch">
  <button
    *ngIf="isGuest; else notGuest"
    aria-label="Login"
    class="btn btn-primary"
    title="Login"
    type="button"
    (click)="login()"
  >
    Login
  </button>

  <ng-template #notGuest>
    <div class="button-width">
      <div
        *ngIf="format === 'eMagazine' && item.magazineIssues?.products.length"
        class="margin-top-10"
      >
        <h6 class="text-center">Issue: {{ magazineEdition }}</h6>
        <button
          role="button"
          type="button"
          aria-label="Select An Issue"
          class="btn btn-primary width-100"
          (click)="openDialog()"
        >
          Select An Issue
        </button>
      </div>

      <div class="button-width">
        <button
          *ngIf="!item.isCheckedOut && item.samples[0]"
          role="button"
          type="button"
          aria-label="View Sample"
          class="btn btn-primary item-buttons"
          title="View Sample Material"
          (click)="showSample(item.samples[0].url)"
        >
          {{ format === 'Audiobook' ? 'Listen To Sample' : 'Read Sample' }}
        </button>
      </div>

      <button
        *ngIf="
          !item.isReserved && !item.availability.available && !item.isCheckedOut;
          else showAvailable
        "
        role="button"
        type="button"
        aria-label="Place Hold"
        class="btn btn-primary item-buttons"
        (click)="placeItemHold()"
      >
        Place Hold
      </button>

      <ng-template #showAvailable>
        <button
          *ngIf="item.isReserved"
          role="button"
          type="button"
          aria-label="Cancel Hold"
          class="btn btn-primary item-buttons"
          title="Cancel Hold"
          (click)="cancelOverDriveHold()"
        >
          Cancel Hold
        </button>

        <button
          *ngIf="item.isCheckedOut"
          role="button"
          type="button"
          aria-label="Early Return Overdrive"
          class="btn btn-primary item-buttons"
          title="Early Return"
          (click)="earlyReturn()"
        >
          Early Return
        </button>

        <ng-container *ngIf="item.isCheckedOut; else notCheckedOut">
          <button
            role="button"
            type="button"
            aria-label="'Get' format"
            class="btn btn-primary item-buttons"
            (click)="goToOverDriveFulfillment()"
          >
            Get {{ format }}
          </button>
        </ng-container>

        <ng-template #notCheckedOut>
          <button
            *ngIf="
              (item.isReadyForPickup && item.isReserved) || (!item.isCheckedOut && !item.isReserved)
            "
            role="button"
            type="button"
            aria-label="Read In Browser"
            class="btn btn-primary item-buttons"
            title="Checkout"
            (click)="checkout()"
          >
            Checkout
          </button>
        </ng-template>
      </ng-template>
    </div>
  </ng-template>
</div>
